import config from 'constants/apiConfig';
import axios from 'axios';

import {
  GET_ALL_ACTIVITY_LOG,
} from 'constants/incident-report-Incident-types';
import { endLoading, startLoading } from 'reducers/loading/loading.action';

// All Activity Logs

export const getAllActivityLogs = () => {
  return (dispatch, getState) => {
    dispatch(startLoading());
    return axios(config.apiGateway.diceActivityLogs, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_ALL_ACTIVITY_LOG, payload: response.data });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        dispatch(endLoading());
      });
  };
};
